import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import OrderStatus from "@/pages/OrderStatus";
import Admin from "@/pages/Admin";
import RefundPolicy from "@/pages/RefundPolicy";
import "@/App.css";

function App() {
  useEffect(() => {
    document.title = "iTMunch Viral Videos — Viral Reels in 24 Hours";
  }, []);
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/order/:id" element={<OrderStatus />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
